import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"

import { LANDING } from "shared/constants/permalinks"
import { useAuth } from "shared/lib/useAuth"
import { useLoginWithIDP } from "shared/lib/useLoginWithIDP"
import { useTimeout } from "shared/lib/useTimeout"

import { useNavigateToPermalink } from "features/navigation/model/useNavigateToPermalink"

import { PostEmailVerificationPageModel } from "../PostEmailVerificationPage"

const POST_EMAIL_VERIFICATION_REDIRECT_TIMEOUT = 3000 // 3 seconds

export function usePostEmailVerificationPageModel(): PostEmailVerificationPageModel {
  const [searchParams] = useSearchParams()
  const verificationFailed = searchParams.get("success") === "false"

  const { isAuthenticated, isLoading } = useAuth()
  const { loginAsVisitor } = useLoginWithIDP()
  const { navigate: navigateToHomepage } = useNavigateToPermalink(LANDING)
  const timeout = useTimeout()

  useEffect(() => {
    if (verificationFailed) return
    if (!isAuthenticated && !isLoading && loginAsVisitor) {
      loginAsVisitor()
    }
  }, [verificationFailed, isAuthenticated, isLoading, loginAsVisitor])

  useEffect(() => {
    if (verificationFailed || !isAuthenticated) return

    timeout.start(POST_EMAIL_VERIFICATION_REDIRECT_TIMEOUT, navigateToHomepage)
  }, [verificationFailed, isAuthenticated])

  return {
    navigateToHomepage,
    verificationFailed
  }
}
